import React from "react";
import styles from "./PeopleUI.module.css";

export default function SectionHeader({
  title,
  count,
  collapsed,
  onToggleCollapse,
  children,
}) {
  return (
    <div className={styles.sectionHeader}>
      <h2 className={styles.sectionTitle}>
        {title}
        {typeof count === "number" && (
          <span className={styles.sectionCount}>{count}</span>
        )}
        {onToggleCollapse && (
          <button
            type="button"
            className={`${styles.collapseChevron} ${collapsed ? styles.collapseChevronCollapsed : ""}`}
            onClick={onToggleCollapse}
            aria-label={collapsed ? `Expand ${title}` : `Collapse ${title}`}
            aria-expanded={!collapsed}
          >
            ▾
          </button>
        )}
      </h2>
      {children && <div className={styles.sectionRight}>{children}</div>}
    </div>
  );
}
